module.exports = __webpack_public_path__ + "img/lv19.820bf80e.png";